'use strict';

const DEVICE_MOBILE = 'mobile',
    DEVICE_TABLET = 'tablet';

const defaultConfig = {
    lazySourceAttr: 'data-lazysrc',
    lazySrcsetAttr: 'data-lazysrcset',
    preloadExpandBy: 0,
    observerId: '',
    deviceAttr: 'data-device',
    breakPointMobile: 480,
    breakPointTablet: 900
},
    loadSuccessClass = 'lazyloaded';

function preloadElement(entry, config) {
    let attribute = '',
        isImage = true;

    if (entry.tagName === 'IMG') {
        attribute = config.lazySourceAttr;
    } else {
        attribute = config.lazySrcsetAttr;
        isImage = false;
    }

    const lazysrc = entry.getAttribute(attribute);
    
    if (isImage) {
        if(entry.classList.contains(loadSuccessClass)) return true;
        if (window.innerWidth > config.breakPointTablet) {
            entry.src = lazysrc;
            entry.classList += ` ${loadSuccessClass}`;
            return true;
        }
    } else {
        switch (entry.getAttribute(config.deviceAttr)) {
            case DEVICE_MOBILE:
                return preloadSource(entry, config.breakPointMobile, lazysrc);
            case DEVICE_TABLET:
                if (window.innerWidth > config.breakPointMobile) {
                        return preloadSource(entry, config.breakPointTablet, lazysrc);
                    }
                break;
            default:
                break;
        }
        return false;
    }
}

function preloadSource(entry, breakPoint, lazysrc) {
    if(entry.classList.contains(loadSuccessClass)) return true;
    if (window.innerWidth <= breakPoint) {
        entry.srcset = lazysrc;
        entry.classList += ` ${loadSuccessClass}`;
        if(entry.nextElementSibling) {
            entry.nextElementSibling.classList += ` sourceloaded`;
        }
        return true;
    }
}

function preloadImages(entry, config, observer) {
    const sources = entry.querySelectorAll(`source:not(${loadSuccessClass})`);
    const images = entry.querySelectorAll(`img:not(${loadSuccessClass})`);
    if(sources.length === 0 && images.length === 0) {
        observer.unobserve(entry.target);
        return;
    }

    [...sources, ...images].forEach(item => {
        preloadElement(item, config);
    });
}

function findSlickParent(element) {
    let parent = element.parentElement;
    while (parent) {
        if (parent.hasAttribute('data-slick') || parent.hasAttribute('data-multicarousel')) {
            return parent;
        }
        parent = parent.parentElement;
    }
    return null;
}

exports.init = function (customConfig = {}) {
    const config = Object.assign(defaultConfig, customConfig);

    let elements = document.querySelectorAll(`[${config.lazySourceAttr}]:not(.${loadSuccessClass}), [${config.lazySrcsetAttr}]:not(.${loadSuccessClass})`);
    let carouselContainers = [];
    let imageElements = [];

    elements.forEach(element => {
        const slickParent = findSlickParent(element);
        if (slickParent) {
            if (!carouselContainers.includes(slickParent)) {
                carouselContainers.push(slickParent);
            }
        }
        const pictureParent = element.parentElement;
        if(!imageElements.includes(pictureParent)) {
            imageElements.push(pictureParent);
        }
    });

    const elementObserver = new IntersectionObserver((entries, elementObserver) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            } else {
                preloadImages(entry.target,config, elementObserver);
            }
        })
    }, {rootMargin: `0px 0px ${config.preloadExpandBy}px 0px`});

    const carouselObserver = new IntersectionObserver((entries, carouselObserver) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            } else {
                preloadImages(entry.target, config, carouselObserver);
            }
        })
    }, {rootMargin: `0px 0px ${config.preloadExpandBy}px 0px`});

    imageElements.forEach(entry => {
        elementObserver.observe(entry);
    });

    carouselContainers.forEach(entry => {
        carouselObserver.observe(entry);
    });

    if (config.observerId === '') return;

    const target = document.querySelector(`#${config.observerId}`);

    if (target === null) return;

    const mutationConfig = { childList: true };
    const mutationCallBack = () => {
        let newElements = document.querySelectorAll(`[${config.lazySourceAttr}]:not(.${loadSuccessClass}), [${config.lazySrcsetAttr}]:not(.${loadSuccessClass})`);
        let newCarouselContainers = [];
        let newImageElements = [];

        newElements.forEach(element => {
            const slickParent = findSlickParent(element);
            if (slickParent) {
                if (!newCarouselContainers.includes(slickParent)) {
                    newCarouselContainers.push(slickParent);
                }
            }
            const pictureParent = element.parentElement;
            if(!newImageElements.includes(pictureParent)) {
                newImageElements.push(pictureParent);
            }
        });

        newImageElements.forEach(entry => {
            elementObserver.observe(entry);
        });

        newCarouselContainers.forEach(entry => {
            carouselObserver.observe(entry);
        });
    };

    const mutationObs = new MutationObserver(mutationCallBack);
    mutationObs.observe(target, mutationConfig);
}




// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/lazypictureload.js